import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }
  render() {
    return this.state.errorInfo || /localhost/.test(window.location.href)
      ? null
      : this.props.children;
  }
}
export default ErrorBoundary;
